/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ContactUsInput = {
    email: string;
    firstName: string;
    lastName: string;
    phone?: string | null;
    comments?: string | null;
};
export type ContactUsUserMutationVariables = {
    input: ContactUsInput;
};
export type ContactUsUserMutationResponse = {
    readonly contactUs: {
        readonly success: boolean;
        readonly error: string | null;
    };
};
export type ContactUsUserMutation = {
    readonly response: ContactUsUserMutationResponse;
    readonly variables: ContactUsUserMutationVariables;
};



/*
mutation ContactUsUserMutation(
  $input: ContactUsInput!
) {
  contactUs(input: $input) {
    success
    error
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ContactUsPayload",
    "kind": "LinkedField",
    "name": "contactUs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactUsUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactUsUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "91869080c49afba90b40307916a85cf9",
    "id": null,
    "metadata": {},
    "name": "ContactUsUserMutation",
    "operationKind": "mutation",
    "text": "mutation ContactUsUserMutation(\n  $input: ContactUsInput!\n) {\n  contactUs(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();
(node as any).hash = '8b932cd899f6c59afffcf10b25e93c0d';
export default node;
